import { render, staticRenderFns } from "./TotalInteractionsChart.vue?vue&type=template&id=e4447b8a"
import script from "./TotalInteractionsChart.vue?vue&type=script&lang=ts"
export * from "./TotalInteractionsChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports